import React, { useState } from "react";

import type { DetailsProps } from "./details.types";

import s from "./details.module.scss";

const Details = ({
  title,
  description,
  classNameTitle = "heading-sm",
  classNameDescription = "body-text-md",
  classNameLink = "link-lemon",
  titleLevel = "h1",
  isExpandable = false,
  maxLength = 100
}: DetailsProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const TitleTag = titleLevel;

  const handleToggle = () => setIsExpanded((prev) => !prev);

  const renderContent = (
    content: string | React.ReactNode,
    isTruncated: boolean
  ) => {
    if (typeof content === "string") {
      const truncatedContent =
        isTruncated && content.length > maxLength
          ? `${content.slice(0, maxLength)}...`
          : content;

      return (
        <div
          className={classNameDescription}
          dangerouslySetInnerHTML={{ __html: truncatedContent }}
        />
      );
    }
  };

  const renderDescription = () => {
    if (!description) return null;

    const isTruncated = !isExpanded && isExpandable;

    return (
      <div>
        {renderContent(description, isTruncated)}
        {isExpandable &&
          typeof description === "string" &&
          description.length > maxLength && (
            <button className={`link ${classNameLink}`} onClick={handleToggle}>
              {isExpanded ? "Fechar" : "Ler mais"}
            </button>
          )}
      </div>
    );
  };

  return (
    <div className={s.details}>
      {title && <TitleTag className={classNameTitle}>{title}</TitleTag>}
      {renderDescription()}
    </div>
  );
};

export default Details;
